import { render, staticRenderFns } from "./ApplicationSubmitRecent.vue?vue&type=template&id=5e87db4e&scoped=true"
import script from "./ApplicationSubmitRecent.vue?vue&type=script&lang=ts"
export * from "./ApplicationSubmitRecent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e87db4e",
  null
  
)

export default component.exports